module.exports = __webpack_public_path__ + "img/polygon-2.1bdc9e7c.svg";